<template>
  <div class="trip-list_container">
    <div
      v-show="from !== 'feifan'"
      class="scene_title blue_header"
    >
      <!-- 灯带场景信息 -->
      <span>{{ title || $t('monitor.sScene') }}</span>
    </div>
    <div class="trip-list">
      <img
        v-if="shapeType === 1 && isTianmu"
        class="trip-list_img"
        src="https://appresource.opple.com/media/business/132/20231218175741_48.png"
      >
      <ul class="trip-list_container">
        <li
          v-for="(item, index) in list"
          :key="item.VDeviceId"
          :class="{ 'trip-list_item': true, 'active': activeKey === item.VDeviceId }"
          @click="handlerActive(item)"
        >
          <div v-if="item.isShuanglu && item.shuangluIndex === 0" class="trip-list_item-shuanglu">
            {{ item.DeviceName }}
          </div>
          <div class="trip-list_item_box">
            <div class="trip-list_item_name">
              <span class="item_index">{{ index + 1 }}</span>
              <span class="item_name">{{ item.DeviceName }}{{ item.IsDel ? ' (' + $t('iftttset.alreadydelete') + ')' : '' }}</span>
              <span v-if="item.deviceNameTag" class="item_tag">{{ item.deviceNameTag }}</span>
            </div>
            <div
              class="trip-list_item_contral"
            >
              <template
                v-if="!hidenControl"
              >
                <span class="trip-list_item_contral_label">{{ $t('scene.lightCount') }}</span>
                <!-- 请输入灯珠数量 -->
                <el-input
                  v-if="values.hasOwnProperty(item.VDeviceId) && !item.IsDel && shapeType !== 1"
                  v-model="values[item.VDeviceId]"
                  :style="{width: '470px'}"
                  class="trip-list_item_contral-lampCount"
              
                  :placeholder="$t('sceneTemplate.lightTripInputLampCount') + '6，10，14，18，22...'"
                  size="medium"
                  @input="() => onAddLamp(item.VDeviceId)"
                  @blur="() => onAddLamp(item.VDeviceId)"
                />
              </template>
              <template v-if="!item.IsDel">
                <OppleAuth code="ActionDevice" :force-show="$store.state.isPassPermission">
                  <el-button
                    class="contral_btn btn-identify"
                    @click="() => onIdentify(item)"
                  >
                    <!-- 识别 -->
                    {{ $t('sync.identification') }}
                  </el-button>
                </OppleAuth>
                <el-button
                  v-if="item.isShuanglu && noRename === false"
                  class="contral_btn btn-identify"
                  @click="() => reNameShuanglu(item, index)"
                >
                  <!-- 识别 -->
                  {{ $t('iftttset.rename') }}
                </el-button>
                <el-button
                  v-if="isShowDownUpShuanglu && isShowDownUp !== false"
                  class="contral_btn btn-up"
                  :disabled="index === 0"
                  @click="() => onUp(index)"
                >
                  <!-- 上移 -->
                  {{ $t('iftttset.upmove') }}
                </el-button>
                <el-button
                  v-if="isShowDownUpShuanglu && isShowDownUp !== false"
                  class="contral_btn btn-down"
                  :disabled="index === list.length - 1 || (list[index + 1] && !!list[index + 1].IsDel)"
                  @click="() => onDown(index)"
                >
                  <!-- 下移 -->
                  {{ $t('iftttset.downmove') }}
                </el-button>
              </template>
            </div>
            <i
              v-if="showDelete"
              class="el-icon-delete"
              @click="handlerDelete(index)"
            />
          </div>
        </li>
      </ul>
      <OppleModal
        :title="$t('iftttset.rename')"
        :visible="isRenameModalVisible"
        @onOk="reNameOk"
        @onClose="isRenameModalVisible = false"
      >
        <el-input
          v-model="renmaneVal"
          :maxlength="7"
          class="userSelectTable_form_ipt"
          placeholder=""
        />
      </OppleModal>
      <el-dialog
        class="imgDialog"
        width="30%"
        destroy-on-close
        :modal-append-to-body="false"
        :title="$t('devicecard.dowarn')"
        :visible="identifyDialogData.visible"
        @close="onHandleClose"
      >
        <img
          class="Dialogimg"
          :src="identifyDialogData.imgSrc"
        >
        <div class="Dialogimg">
          {{ identifyDialogData.desc }}
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { alerterror } from "@/assets/js/common.js";
import { GetIdentifyInfo, PositiveIdentify } from '@/axios/IDevice';
import { LAMP_LAYOUT_SERVICE_MODE } from  "@/components/DrawCanvas/enums/index";
import OppleModal from '@/components/OppleModal/index.vue';

export default {
  components: {
    OppleModal
  },
  props: {
    isShowDownUp: {
      type: Boolean,
      default: true
    },
    noRename: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    from: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: () => []
    },
    canvasInitData: {
      type: Object,
      default: () => ({})
    },
    shapeType: {
      type: Number,
      default: 1
    },
    hidenControl: {
      type: Boolean,
      default: false
    },
    isTianmu: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    version: {
      type: Number,
      default: 0
    },
    drawCanvasInstance: {
      type: null,
      default: null
    }
  },
  data() {
    return {
      isAlive: true,
      renmaneVal: '',
      currentRenameItemIndex: -1,
      // 识别弹窗
      identifyDialogData: {
        imgSrc: '',
        desc: '',
        visible: false
      },
      values: {},
      activeKey: null,
      paddingAddLamp: [],
      isRenameModalVisible: false,
      // 记录已注册的 socket 设备，用于销毁时清理
      registeredSocketDevices: []
    }
  },

  computed: {
    isShowDownUpShuanglu() {
      return this.list.every(item => !item.isShuanglu);
    }
  },

  watch: {
    canvasInitData() {
      this.initCustomize();
    },
    values(values) {
      console.log('values values', values);
    },
    drawCanvasInstance(newVal, pre) {
      if (!pre && !!newVal) {
        this.paddingAddLamp.forEach(VDeviceId => {
          this.onAddLamp(VDeviceId);
        });

        const firstVDeviceId = this.paddingAddLamp[0];

        if (firstVDeviceId) {
          this.setActiveKey(firstVDeviceId);
          this.$emit('onTripActive', firstVDeviceId);
        };
      }
    }
  },

  mounted() {
    this.initCustomize();
  },

  beforeDestroy() {
    this.isRenameModalVisible = false;
    this.onHandleClose();

    this.isAlive = false;

    if (this.registeredSocketDevices.length > 0) {
      this.registeredSocketDevices.forEach(mac => {
        postWebIOSocket("sync_info_remove_event", {
          data: [{
            projectCode: this.$store.state.projectcode,
            type: 3,
            id: mac
          }]
        });
      });
      this.registeredSocketDevices = [];
    }

    this.activeKey = null;
    this.paddingAddLamp = [];
    this.values = {};
    this.renmaneVal = '';
    this.currentRenameItemIndex = -1;

  },

  destroyed() {
    if (this.$el && this.$el.__vue__) {
      this.$el.__vue__ = null;
    }
    this._vnode = null;
  },

  methods: {    
    reNameOk() {
      const newList = this.list.map((item, index) => {
        if (index === this.currentRenameItemIndex) {
          return {
            ...item,
            deviceNameTag: this.renmaneVal
          }
        } else {
          return item;
        }
      });

      this.$emit('updateDeviceList', newList);
      this.isRenameModalVisible = false;
    },

    reNameShuanglu(item, index) {
      this.currentRenameItemIndex = index;
      this.renmaneVal = item.deviceNameTag;
      this.isRenameModalVisible = true;
    },

    initCustomize() {
      const modeData = (this.canvasInitData || {}).modeData || {};
      const idValues = {};
      let needAddLamp = false;

      this.list.forEach(device => {
        const VDeviceId = device.VDeviceId;
        const lampData = modeData[VDeviceId] || {};
        let value = ''

        // // 初次
        // if (this.canvasInitData === null && device.isShuanglu && device.shuangluLampCount) {
        //   value = device.shuangluLampCount;
        //   needAddLamp = true;
        // }

        // if (lampData.l && lampData.l.m === LAMP_LAYOUT_SERVICE_MODE.AVERAGE) {
        //   value = lampData.l.c;
        // }

        // if (lampData.l && lampData.l.m === LAMP_LAYOUT_SERVICE_MODE.SIMGLE_LINE_AVERAGE && lampData.l.l) {   
        //   value = lampData.l.l.join(',');
        // }

        // 初次
        if (device.isShuanglu && device.shuangluLampCount) {
          value = device.shuangluLampCount;
          needAddLamp = true;

          if (lampData.l && lampData.l.m === LAMP_LAYOUT_SERVICE_MODE.SIMGLE_LINE_AVERAGE && lampData.l.l) {
            const all = lampData.l.l.map(item => Number(item) || 0).reduce((a, b) => a + b);

            if (all === Number(value)) {
              value = lampData.l.l.join(',');
            } else {
              value = lampData.l.l.join(',');
            }
          }
        } else {
          if (lampData.l && lampData.l.m === LAMP_LAYOUT_SERVICE_MODE.AVERAGE) {
            value = lampData.l.c;
          }

          // 如果是,肯定有问题
          if (lampData.l && lampData.l.m === LAMP_LAYOUT_SERVICE_MODE.SIMGLE_LINE_AVERAGE && lampData.l.l) {   
            value = lampData.l.l.join(',');
          }
        }

        

        idValues[VDeviceId] = value;
      })

      this.values = idValues;

      if (needAddLamp) {
        this.paddingAddLamp = Object.keys(idValues);
      }

      const firstDevice = this.list[0];

      if (firstDevice) {
        this.setActiveKey(firstDevice.VDeviceId);
        this.$emit('onTripActive', firstDevice.VDeviceId);
      };
    },
  
    setActiveKey(VDeviceId) {
      this.activeKey = VDeviceId;
    },

    // emitLampValue(VDeviceId) {
    //   const countStr = this.values[VDeviceId];
    //   const isRegValue = /^(\d+,?)+$/g.test(countStr);

    //   if (countStr.trim() === '') {

    //     // return {
    //     //   lampCount: 0, lampInfoList: null
    //     // }
    //   }

    //   if (!isRegValue) {
    //     this.values[VDeviceId] = this.values[VDeviceId].replace(/[^\d|\,]/g, '');

    //     return;
    //   }
    //   const realValue = this.values[VDeviceId];
    //   let lampCount = 0;
    //   let lampInfoList = null;
    //   const MAX = 500;

    //   if (realValue.includes(',')) {
    //     lampInfoList = realValue.split(',').map(item => Math.min(Number(item) || 0, MAX));

    //     lampCount = lampInfoList.reduce((a, b) => a + b)
    //   } else {
    //     lampCount = Math.min(Number(realValue) || 0 , MAX);
    //   }

    // },

    handlerDelete(i) {
      if (this.list.length === 1) return this.$message.error(this.$t('sceneCard.leastOne'));

      this.$emit('updateList', this.list.filter((item, index) => index !== i), i);
    },

    onAddLamp(VDeviceId) {
      const countStr = `${this.values[VDeviceId]}`;
      const isRegValue = /^(\d+,?)+$/g.test(countStr);
  
      if (countStr.trim() === '') {
        this.$emit('onAddLamp', VDeviceId, 0, [0]);
      }
      
      if (!isRegValue) {
        this.values[VDeviceId] = countStr.replace(/[^\d|\,]/g, '');

        return;
      }
      const realValue = `${this.values[VDeviceId]}`;
      let lampCount = 0;
      let lampInfoList = null;
      const MAX = 500;

      if (realValue.includes(',')) {
        lampInfoList = realValue.split(',').map(item => Number(item) || 0);

        lampCount = lampInfoList.reduce((a, b) => a + b)
      } else {
        lampCount = Math.min(Number(realValue) || 0 , MAX);
        lampInfoList = [lampCount];
      }


      this.$emit('onAddLamp', VDeviceId, lampCount, lampInfoList);
    },

  
    handlerActive(item) {
      const { VDeviceId, IsDel } = item;

      this.setActiveKey(VDeviceId);
      this.$emit('onTripActive', VDeviceId);

      this.onAddLamp(VDeviceId)

      // const lampCount = this.values[VDeviceId];

      // if (lampCount) {
      //   this.$emit('onAddLamp', VDeviceId, lampCount);
      // }
    },
    // 上移
    onUp(clickIndex) {
      if (clickIndex === 0) return;

      const replaceIndex = clickIndex - 1;
      const clickItem = this.list[clickIndex];
      const replaceItem = this.list[replaceIndex];
      const newList = [...this.list];

      newList[replaceIndex] = clickItem;
      newList[clickIndex] = replaceItem;

      this.$emit('onSort', newList);
    },
    // 下移
    onDown(clickIndex) {
      if (clickIndex === this.list.length -1) return;

      const replaceIndex = clickIndex + 1;
      const clickItem = this.list[clickIndex];
      const replaceItem = this.list[replaceIndex];
      const newList = [...this.list];

      newList[replaceIndex] = clickItem;
      newList[clickIndex] = replaceItem;

      this.$emit('onSort', newList);
    },

    // 识别
    onIdentify(item) {
      const para = { classSku: item.ClassSku, channelId: item.ChannelId };

      // if (item.isShuanglu) {
      //   para.channelId = item.shuangluIndex + 1
      // }

      GetIdentifyInfo(para, this.reqIdentifyInfo, item);
    },

    /* 获得设备的识别方式接口返回数据处理
    * rs：接口原始数据包
    * para：传递的参数
    * model：设备对象
    */
    reqIdentifyInfo (res, para, model) {
      if (!this.isAlive) return;

      if (res.StatusCode === this.$store.state.rightStatusCode) {
        const para = res.Result;
// debugger
//         if (model.isShuanglu) {
//         para.channelId = model.shuangluIndex + 1
//       }

        // 去识别
        this.doPositiveIdentify(para, model);
      } else {
        alerterror(this, res.StatusCode);
      }
    },

    /* 去识别设备
    * result：接口原始数据包
    * model：设备对象
    */
    doPositiveIdentify (res, model) {
      if (!this.isAlive || !res) return;

      if (
        [1, 2].includes(res.IdentifyType)
      ) {
        this.dosocket(model);
        this.showDialog(res, model);
      } else {
        const para = {
          mac: model.Mac,
          deviceId:  model.realVDeviceId || model.VDeviceId,
          channelId: model.ChildId || model.ChannelId
        }

        if (model.isShuanglu) {
          para.channelId = model.shuangluIndex + 1
        }

        if (!para.mac || !para.deviceId || !para.channelId) return;
  
        PositiveIdentify(para, this.reqPositiveIdentify, model);
      }
    },

      // 展示弹窗
    showDialog(result, model) {
      const imgSrc = this.getDialogImgUrl(result, model);

      this.identifyDialogData = {
        ...this.identifyDialogData,
        imgSrc,
        desc: result.IntroDesc,
        visible: true
      };
    },

    // 关闭弹窗
    onHandleClose() {
      this.identifyDialogData = {
        imgSrc: '',
        desc: '',
        visible: false
      };
    },

    /* 注册socket
      * model：设备对象
      */
    dosocket(model) {
      const para = {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 3,
            id: model.Mac,
          },
        ],
      };

      // 记录已注册的设备
      if (!this.registeredSocketDevices.includes(model.Mac)) {
        this.registeredSocketDevices.push(model.Mac);
      }

      postWebIOSocket("sync_info_add_event", para);
    },

    /**
     * 识别后弹窗图片
     * @param {*} model 
     * @param {*} result 
     */
    getDialogImgUrl(model, result) {
      if (model.VDeviceId === '0x02000308') {
        return '/static/device/identify/nonev2.png';
      } else if (
        result.IntroImage == "" ||
        result.IntroImage == null ||
        result.IntroImage.startsWith("http")
      ) {
        return '/static/device/identify/none.png';
      } else {
        return '/static/device/identify/' + result.IntroImage;
      }
    },
    /* 识别设备处理方法
      * rs：接口返回的原始数据包
      * para：向接口传递的参数
      * model：当前识别的设备对象
      */
    reqPositiveIdentify(res, para, model) {
      if (!this.isAlive) return;

      if (
        res.StatusCode === this.$store.state.rightStatusCode
      ) {
        // model.isflicker = true;

        // setTimeout(() => {
        //   model.isflicker = false;
        // }, 2000);

      } else {
        alerterror(this, res.StatusCode);
      }
    },

    resetValues() {
      const idValues = {};

      this.list.forEach(device => {
        idValues[device.VDeviceId] = '';
      })

      this.values = idValues;

      const firstDevice = this.list[0];

      if (firstDevice) {
        this.setActiveKey(firstDevice.VDeviceId);
      };
    }
  },
};
</script>

<style lang="scss" scoped>
.trip-list {
  margin-top: 40px;
  padding: 20px 45px;
  border: solid 1px #e0e3e6;
  max-height: 900px;
  overflow: scroll;
  margin-bottom: 50px;

  &_container {
    // margin-bottom: 50px;
  }

  &_img {
    margin-bottom: 10px;
  }

  .trip-list_item {
    &_box {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 19px;
      margin-bottom: 8px;
      background: #F4F5F8;
      border: 1px solid #E0E3E6;
    }

    &.active .trip-list_item_box {
      background-color: #DEE8FC;
    }

    &-shuanglu {
      padding: 16px 0;
    }
  
    .trip-list_item_contral {
      display: flex;
      align-items: center;
      margin-right: 26px;

      &_label {
        margin-right: 10px;
        color: #A1A1A1;
      }
    }

    .trip-list_item_contral-lampCount {
      width: 140px;
      margin-right: 56px;
    }

    .trip-list_item_name {
      span:first-child {
        padding-right: 25px;
      }

      .item_index {
        font-size: 10px;
        font-weight: 400;
        color: #409EFF;
      }

      .item_name {
        font-size: 12px;
        font-weight: 400;
        color: #0042A6;
      }

      .item_tag {
        padding: 2px 4px;
        margin-left: 6px;
        border-radius: 3px;
        background: #002e94;
        color: #fff;
        word-break: keep-all;
      }
    }

    .btn-identify {
      margin-right: 45px;
    }
  }

  .el-icon-delete {
    position: absolute;
    cursor: pointer;
    right: 20px;
    top: 28px;
  }
}

</style>